var A={COACH:"COACH",GENERAL_MANAGER:"GENERAL_MANAGER",GOALIE:"GOALIE",SKATER:"SKATER"};export{A as default};
